import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-foreground-900">
                Kakobuy<span className="text-primary-500">Polska</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              Niezależny przewodnik po Kakobuy Spreadsheet dla polskich użytkowników. Znajduj najlepsze produkty, porównuj ceny i korzystaj z wiedzy społeczności.
            </p>
            <p className="text-xs text-foreground-400 italic">
              Nie jesteśmy oficjalną stroną Kakobuy. Tworzymy niezależny przewodnik informacyjny.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Nawigacja</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">Strona główna</Link>
              </li>
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-poradnik" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">Poradnik</Link>
              </li>
              <li>
                <Link to="/#bezpieczenstwo" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">Bezpieczeństwo</Link>
              </li>
              <li>
                <Link to="/#faq" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors">FAQ</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Kategorie</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Więcej kategorii</h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} KakobuyPolska.casa – Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
            >
              Kakobuy Spreadsheet
            </a>
            <span className="text-foreground-300">·</span>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}